import { Create, Edit, List, Show, CategoryItems, DataTable } from "../Components/index.js";

export default [
    {
        path: "/property/category",
        component: DataTable,
        name: "property.category",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/category/create",
        component: Create,
        name: "property.category.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/category/:id/items",
        component: CategoryItems,
        name: "property.category.items",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/category/:id/edit",
        component: Edit,
        name: "property.category.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
